import React from 'react';
import PropTypes from 'prop-types';
import { generatePath, Link } from 'react-router-dom';
import { USER_LINK_PATHS } from 'App/features/UserManager/constants';

const propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    }).isRequired,
    value: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['edit', 'disabled']).isRequired,
};

const defaultProps = {};

function UserLinkCell({ value, row, type }) {
    const user = row.original;

    const { path } = USER_LINK_PATHS[type];

    return <Link to={generatePath(path, { userId: user.id })}>{value}</Link>;
}

UserLinkCell.propTypes = propTypes;
UserLinkCell.defaultProps = defaultProps;

export default UserLinkCell;
